/* 1776 Atelier — Watch Making. Motion belongs to arrival and to scroll.
   Nothing here reads the cursor; nothing moves on hover. Everything that
   arrives, rests. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- staged hero entrance ---- */
  var enters = [].slice.call(document.querySelectorAll('[data-enter]'));
  enters.forEach(function (el, i) { el.style.transitionDelay = (120 + i * 140) + 'ms'; });
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      enters.forEach(function (el) { el.classList.add('is-on'); });
      setTimeout(function () { enters.forEach(function (el) { el.style.transitionDelay = ''; }); }, 2600);
    });
  });

  /* ---- scroll reveals, staggered per arriving batch ---- */
  var els = [].slice.call(document.querySelectorAll('[data-reveal], [data-rise]'));
  if (!('IntersectionObserver' in window) || reduce) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var batch = [], flush = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        batch.push(e.target);
        io.unobserve(e.target);          /* arrival happens once */
      });
      if (batch.length && !flush) {
        flush = requestAnimationFrame(function () {
          batch.sort(function (a, b) {
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
          batch.forEach(function (el, i) {
            el.style.setProperty('--rd', Math.min(i * 110, 660) + 'ms');
            el.classList.add('is-in');
          });
          batch = []; flush = null;
        });
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- the rail follows the reader ---- */
  var chapters = [].slice.call(document.querySelectorAll('[data-chapter]'));
  var links = {};
  [].slice.call(document.querySelectorAll('[data-rail]')).forEach(function (a) {
    links[a.getAttribute('data-rail')] = a;
  });
  var rail = document.querySelector('.wm-rail');
  /* the rail only exists while a chapter is on screen — never over the
     hero, the opening or the closing, so those stay centred and clear */
  if (rail && chapters.length && 'IntersectionObserver' in window) {
    var onScreen = new Set();
    var live = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target);
      });
      rail.classList.toggle('is-live', onScreen.size > 0);
    }, { threshold: 0 });
    chapters.forEach(function (c) { live.observe(c); });
  }

  if (chapters.length && 'IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var a = links[e.target.getAttribute('data-chapter')];
        if (!a) return;
        if (e.isIntersecting) {
          Object.keys(links).forEach(function (k) { links[k].classList.remove('is-here'); });
          a.classList.add('is-here');
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    chapters.forEach(function (c) { spy.observe(c); });
  }

  /* ---- progress thread (only when the browser can't do it in CSS) ---- */
  var thread = document.getElementById('wm-thread');
  var cssDrivesIt = CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()');
  if (thread && !cssDrivesIt) {
    var ticking = false;
    var paint = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? (window.scrollY / h) : 0;
      thread.style.width = (p * 100).toFixed(2) + '%';
      ticking = false;
    };
    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }
})();
